import { useContext, useEffect, useState } from 'react'
import { Life } from '@/pages/Dojo/components/Icons.jsx'
import kalvium from '@kalvi-education/kalvium-sdk'
import ATTEMPT_ACTION from '@/enums/attemptActions'
import AttemptContext from '@/contexts/AttemptContext.js'
import { AuthContext } from '@/contexts/AuthContext'

const Warning = ({
    isOpen,
    onOpen,
    remLives,
    autoSubmitWarningMessage,
    resumeTest,
    isScreenExtended,
    isFullScreenIntegrityMode,
}) => {
    if (!isOpen) return null

    const handleResume = () => {
        if (remLives > 0) {
            resumeTest()
        }
    }
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* Overlay backdrop with blur */}
            <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" />
            <div className="relative w-[710px] bg-white border-2 border-black shadow-[8px_8px_0_#333333]">
                {autoSubmitWarningMessage && isFullScreenIntegrityMode && (
                    <div className="w-full bg-[#B91C1C] flex justify-center items-center tracking-wide h-[80px] border-b-2 border-[#EF4444]">
                        {autoSubmitWarningMessage()}
                    </div>
                )}
                <div className="m-12 p-0">
                    <div className="flex items-center justify-center">
                        <img
                            src="/images/fullscreen-warning.svg"
                            alt="warning"
                        />
                    </div>

                    <div className="flex flex-col text-center">
                        <p className="my-6">
                            {isScreenExtended
                                ? remLives > 1
                                    ? `A secondary display connection was detected. External screens are not allowed during the assessment and will cost you one life.`
                                    : `Final Warning! Another secondary display detection will lead to immediate automatic submission of your attempt.`
                                : remLives > 1
                                ? `It seems like you attempted to close/navigate away from the assessment window. We understand that it can be an accident, but please note that exiting the assessment window will result in the loss of a life.`
                                : `Attention! It appears that you tried to leave/navigate away from the assessment window. Please be aware that if you exit the assessment window again, your attempt will be automatically submitted.`}
                        </p>
                        <p className="flex items-center justify-center">
                            <Life
                                color="#3689B0"
                                borderColor="#333333"
                                w={6}
                                h={6}
                                mr={2}
                            />
                            You have {remLives}{' '}
                            {remLives === 1 ? 'life' : 'lives'} left.
                        </p>
                    </div>

                    <hr className="w-full mt-8 border-t border-gray-300" />
                    <div className="flex items-center justify-center mt-6">
                        <button
                            onClick={handleResume}
                            className="flex items-center px-4 py-2 text-[#FFFFFF] text-10 font-bold bg-[#CB3434] border-[3px] border-black"
                        >
                            I Understand, Go Full Screen
                            <Life
                                color="#3689B0"
                                borderColor="#333333"
                                w={6}
                                h={6}
                                className="ml-2"
                            />
                            <span className="ml-2">{remLives}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Warning
